// extracted by mini-css-extract-plugin
export default {"conditions":"referralForm_conditions__Y-9iS"};